var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location-edit"},[_c('edit',{attrs:{"api":"locations","id":_vm.id,"fs":_vm.locationFields},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }